import { render, staticRenderFns } from "./QuotaExtItem.vue?vue&type=template&id=20b3f872&scoped=true"
import script from "./QuotaExtItem.vue?vue&type=script&lang=js"
export * from "./QuotaExtItem.vue?vue&type=script&lang=js"
import style0 from "./QuotaExtItem.vue?vue&type=style&index=0&id=20b3f872&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b3f872",
  null
  
)

export default component.exports